import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Announcements = () => (
  <Box className="dashboard-card">
    <Typography variant="h6">Announcements</Typography>
    <Box sx={{ mt: 2 }}>
    <Typography variant="body2" fontWeight="bold">
      Coming soon.
    </Typography>
      {/* <Typography variant="body2" fontWeight="bold">
        • Q3 Update <Link href="#">[Doc]</Link> <Link href="#">[Video]</Link>
      </Typography>
      <Typography variant="caption" color="textSecondary" display="block" sx={{ ml: 2 }}>
        Investor call and video via Docsend.
      </Typography> */}
    </Box>
  </Box>
);

export default Announcements;